import { useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  Avatar,
  Stack,
} from '@mui/material';
import { Menu, Logout } from '@mui/icons-material';
import { logoutUser } from '../store/slice/authenticationSlice';

function DashboardNavbar({ onMobileNavOpen, ...rest }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    navigate('/login', { replace: true });
    dispatch(logoutUser());
  };

  return (
    <AppBar
      elevation={0}
      {...rest}
    >
      <Toolbar>
        <RouterLink to="/">
          <Stack direction="row" spacing={2}>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ height: 50 }}
            >
              <Avatar
                alt="Rewot Logo"
                variant="square"
                src="/static/images/logo.png"
              />
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography color="white" variant="h3" component="h2">
                Rewot Ciro Dashboard
              </Typography>
            </Box>

          </Stack>
        </RouterLink>

        <Box sx={{ flexGrow: 1 }} />
        <Hidden lgDown>
          {/* <IconButton color="inherit" size="large">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          <IconButton color="inherit" size="large" onClick={logout}>
            <Logout />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
